import React from 'react';

/* Icons */
import GearIcon from '~/../symbols/gear-fill.svg';
import DocumentIcon from '~/../symbols/invoice-fill.svg';
import HourglassIcon from '~/../symbols/hourglass-fill.svg';

/* Common */
import { Icon } from '~/components/common';

/* Utilities */
import { trans } from '~/utilities';

export default function ConversionFooterOnlinePurchase() {
    const steps = [
        { step: 1, icon: GearIcon },
        { step: 2, icon: DocumentIcon },
        { step: 3, icon: HourglassIcon },
    ];

    return (
        <div className="flow-walkthrough row gutters-2 gutters-lg-4">
            {steps.map(({ step, icon }) => (
                <div key={step} className="col-12 col-xl-4">
                    <div className="row gutters-2 gutters-lg-4">
                        <div className="col-auto col-xl-12">
                            <div className="d-flex align-items-center">
                                <Icon
                                    theme="primary"
                                    url={icon?.url}
                                    className={`flow-walkthrough__icon`}
                                />
                                <div className="flow-walkthrough__line ml-4 d-none d-xl-block"></div>
                            </div>
                        </div>
                        <div className="col col-xl-12">
                            <p className="text--sm font-weight-bold mb-1 mb-xl-2">{trans(`app.flow.online_purchase.footer.walkthrough.step_${step}.title`)}</p>
                            <p className="text--xs">{trans(`app.flow.online_purchase.footer.walkthrough.step_${step}.text`)}</p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
